module.exports = __webpack_public_path__ + "img/2.4a5e6f27.jpg";